<template>
    <CToast>
        <CToastHeader close-button>
            {{ headerText }}
        </CToastHeader>
        <CToastBody :class="{'body': bodyClass}">
            <span v-if="Array.isArray(bodyText) === false">
                {{ bodyText }}
            </span>
            <div
                v-for="(message, key) in bodyText"
                v-else
                :key="key"
            >
                - {{ message }}
            </div>
        </CToastBody>
    </CToast>
</template>

<script setup>
import { CToast, CToastBody, CToastHeader } from '@coreui/vue-pro'

defineProps({
    headerText: {
        type: String,
        default: ''
    },
    bodyText: {
        type: [String, Array],
        default: ''
    },
    bodyClass: {
        type: Boolean,
        default: false
    }
})
</script>

<style scoped>
.body {
    background-color: #ffffff !important;
    color: red !important;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}

</style>
